<app-search-bar
  (searchTermChanged)="searchTermChanged($event)"
  [placeholder]="'bank_choice_search' | translate"
></app-search-bar>

@if (searchTerm === undefined || searchTerm.trim() === '') {
  <app-regional-bank [regionalBanks]="regionalBankOption"></app-regional-bank>
} @else {
  <app-regional-bank [regionalBanks]="filteredRegionalBankOption"></app-regional-bank>
}
